module.exports = __webpack_public_path__ + "static/media/map-desktop.fb7cff96.svg";